import { useRef } from "react";
import { Button } from "react-bootstrap";
import { CountingIndicator } from "./CountingIndicator";
import { PlayingIndicator } from "./PlayingIndicator";
import { useAudioState as defaultUseAudioState } from "./useAudioState";

interface Props {
  className?: string;
  audioSrc: string;
  countdownFrom?: number; // In seconds
  useAudioState?: typeof defaultUseAudioState; // For mocking in storybook
}

export const AssignmentAudio: React.FC<Props> = ({
  className,
  audioSrc,
  countdownFrom = 5,
  useAudioState = defaultUseAudioState,
}) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const { state, countdown, currentSrc, handleAudioEnded, handleStartManually } = useAudioState(
    audioRef,
    audioSrc,
    countdownFrom,
  );

  return (
    <div className={`assignment-audio ${className ?? ""}`}>
      {state === "counting" && (
        <>
          <p style={{ fontSize: "25px" }}>👂</p>
          <p>
            <strong>Nahrávka se spustí za…</strong>
          </p>
          <CountingIndicator className="mt-3" countdown={countdown} />
        </>
      )}

      {(state === "playing" || state === "not-started") && (
        <>
          <audio ref={audioRef} src={currentSrc} onEnded={handleAudioEnded} preload="auto" />

          {state === "playing" && (
            <>
              <p>
                <strong>Audio se přehrává…</strong>
              </p>
              <PlayingIndicator className="mt-3" />
            </>
          )}
          {state === "not-started" && (
            <>
              {" "}
              <p>
                <strong>Audio se nepodařilo spustit automaticky.</strong>
              </p>
              <Button className="mt-3" size="sm" variant="outline-secondary-darker" onClick={handleStartManually}>
                Spustit ručně
              </Button>
            </>
          )}
        </>
      )}

      {state === "finished" && (
        <>
          <p>
            Nahrávka se právě přehrála.
            <br />
            Nyní zadejte svou odpověď.
          </p>
        </>
      )}

      {state === "error" && (
        <>
          <p>Nahrávku se nepodařilo přehrát :-(</p>
        </>
      )}
    </div>
  );
};
